/*************************************************/
/* SELF CONTROL                                  */
/*************************************************/

export function selfControl() {

    const init = () => {

        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params != null) {
            const fieldSets = document.querySelectorAll('.umbraco-forms-fieldset');
            if (fieldSets != null && fieldSets.length) {
                fieldSets.forEach(fieldSet => {
                    const formFields = fieldSet.querySelectorAll('[data-form-field-alias]');
                    if (formFields != null && formFields.length) {
                        formFields.forEach(formField => {
                            const formFieldAlias = formField.dataset.formFieldAlias;
                            const formFieldInputElements = formField.querySelectorAll('input:not([type="hidden"])');
                            if (formFieldInputElements != null && formFieldInputElements.length && formFieldAlias != null) {
                                formFieldInputElements.forEach(formFieldInputElement => {
                                    if (formFieldInputElement.getAttribute('type') == 'radio' && formFieldInputElement.value == params[formFieldAlias]) {
                                        formFieldInputElement.checked = true;
                                    } else if (formFieldInputElement.classList.contains('datepickerfield')) {
                                        if (params[formFieldAlias] != null) {
                                            formFieldInputElement.previousElementSibling.value = params[formFieldAlias];
                                            formFieldInputElement.value = params[formFieldAlias];
                                        }
                                    } else {
                                        if (params[formFieldAlias] != null) {
                                            formFieldInputElement.value = params[formFieldAlias];
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }
    };

    init();
}
